import jsPDF from "jspdf";
import "jspdf-autotable";
import { numberWithCommas } from "../helpers/app/numberFormater";
import image from "../../assets/logo/authLogo.png";
import { centrePdfText } from "../helpers/app/pdf";
import dayjs from "dayjs";

const generateBalanceSheetPdf = (data, asOfDate) => {
  const doc = new jsPDF();
  doc.setFontSize(10);
  doc.addImage(image, "PNG", 60, 15, 80, 25);
  centrePdfText(
    doc,
    "P.O.BOX 610029, Maracha, Uganda | Adongoro Cell, Maracha Town Council",
    45
  );
  centrePdfText(doc, "Mob: +256 393102379", 60);
  centrePdfText(
    doc,
    "Web: www.amaniinitiative.org | Email: info.amaniinitiative@gmail.com",
    65
  );
  centrePdfText(doc, "AMANI INITIATIVE BALANCE SHEET", 75);
  doc.text(`As at: ${dayjs(asOfDate).format("DD MMMM YYYY")}`, 14, 85);

  const assets = data?.assets || {};
  const liabilities = data?.liabilities || {};
  const equity = data?.equity || {};
  const totals = data?.totals || {};

  const cashBankItems = assets?.cashBank?.items || [];
  const totalCashBank = assets?.cashBank?.total || 0;
  const inventoryValue = assets?.inventory?.value || 0;
  const fixedAssetsItems = assets?.fixedAssets?.items || [];
  const totalFixedAssets = assets?.fixedAssets?.total || 0;
  const totalAssets = assets?.total || 0;

  const liabilityItems = liabilities?.items || [];
  const totalLiabilities = liabilities?.total || 0;

  const accumulatedFundOB = equity?.accumulatedFundOB || 0;
  const surplus = equity?.surplus || 0;
  const totalEquity = equity?.total || 0;

  const isBalanced = totals?.isBalanced || false;
  const balanceCheck = totals?.balanceCheck || 0;

  let startY = 95;

  // Assets Section
  doc.setFontSize(12);
  doc.text("ASSETS", 14, startY);
  startY += 8;

  // Cash at Bank/Hand
  doc.setFontSize(11);
  doc.text("Cash at Bank/Hand", 14, startY);
  startY += 8;

  const cashBankColumns = ["Account Name", "Account Type", "Balance (UGX)"];
  const cashBankRows = [];

  cashBankItems.forEach((item) => {
    cashBankRows.push([
      item.accountName || "",
      item.accountType || "",
      item.balance ? numberWithCommas(item.balance) : "0",
    ]);
  });

  cashBankRows.push(["TOTAL CASH AT BANK/HAND", "", numberWithCommas(totalCashBank)]);

  doc.autoTable(cashBankColumns, cashBankRows, { startY });

  let { finalY: cashBankFinalY } = doc.lastAutoTable;
  startY = cashBankFinalY + 10;

  // Inventory
  doc.setFontSize(11);
  doc.text("Inventory", 14, startY);
  if (assets?.inventory?.note) {
    doc.setFontSize(9);
    doc.text(`(${assets.inventory.note})`, 50, startY);
  }
  doc.setFontSize(11);
  doc.text(`UGX ${numberWithCommas(inventoryValue)}`, 150, startY);
  startY += 15;

  // Fixed Assets
  doc.setFontSize(11);
  doc.text("Fixed Assets", 14, startY);
  if (assets?.fixedAssets?.note) {
    doc.setFontSize(9);
    doc.text(`(${assets.fixedAssets.note})`, 50, startY);
  }
  startY += 8;

  const fixedAssetsColumns = ["Asset Name", "Net Book Value (UGX)"];
  const fixedAssetsRows = [];

  fixedAssetsItems.forEach((item) => {
    fixedAssetsRows.push([
      item.assetName || "",
      item.netBookValue ? numberWithCommas(item.netBookValue) : "0",
    ]);
  });

  fixedAssetsRows.push(["TOTAL FIXED ASSETS", numberWithCommas(totalFixedAssets)]);

  doc.autoTable(fixedAssetsColumns, fixedAssetsRows, { startY });

  let { finalY: fixedAssetsFinalY } = doc.lastAutoTable;
  startY = fixedAssetsFinalY + 10;

  // Total Assets
  doc.setFontSize(12);
  doc.text("TOTAL ASSETS", 14, startY);
  doc.text(`UGX ${numberWithCommas(totalAssets)}`, 150, startY);
  startY += 20;

  // Liabilities Section
  doc.setFontSize(12);
  doc.text("LIABILITIES", 14, startY);
  startY += 8;

  const liabilitiesColumns = ["Account Name", "Balance (UGX)"];
  const liabilitiesRows = [];

  liabilityItems.forEach((item) => {
    liabilitiesRows.push([
      item.accountName || "",
      item.balance ? numberWithCommas(item.balance) : "0",
    ]);
  });

  liabilitiesRows.push(["TOTAL LIABILITIES", numberWithCommas(totalLiabilities)]);

  doc.autoTable(liabilitiesColumns, liabilitiesRows, { startY });

  let { finalY: liabilitiesFinalY } = doc.lastAutoTable;
  startY = liabilitiesFinalY + 20;

  // Equity Section
  doc.setFontSize(12);
  doc.text("EQUITY", 14, startY);
  startY += 8;

  doc.setFontSize(10);
  doc.text("Accumulated Fund (OB)", 14, startY);
  doc.text(`UGX ${numberWithCommas(accumulatedFundOB)}`, 150, startY);
  startY += 8;

  doc.text("Surplus", 14, startY);
  if (surplus >= 0) {
    doc.setTextColor(82, 196, 26); // Green
  } else {
    doc.setTextColor(255, 77, 79); // Red
  }
  doc.text(`UGX ${numberWithCommas(surplus)}`, 150, startY);
  doc.setTextColor(0, 0, 0); // Reset to black
  startY += 8;

  doc.setFontSize(12);
  doc.text("TOTAL EQUITY", 14, startY);
  doc.text(`UGX ${numberWithCommas(totalEquity)}`, 150, startY);
  startY += 20;

  // Balance Check
  doc.setFontSize(11);
  doc.text("Total Assets:", 14, startY);
  doc.text(`UGX ${numberWithCommas(totalAssets)}`, 80, startY);
  startY += 8;

  doc.text("Total Liabilities + Equity:", 14, startY);
  doc.text(`UGX ${numberWithCommas(totalLiabilities + totalEquity)}`, 80, startY);
  startY += 10;

  if (isBalanced) {
    doc.setTextColor(82, 196, 26); // Green
    doc.text(
      `Balance Sheet is Balanced: Assets (UGX ${numberWithCommas(totalAssets)}) = Liabilities + Equity (UGX ${numberWithCommas(totalLiabilities + totalEquity)})`,
      14,
      startY
    );
  } else {
    doc.setTextColor(255, 77, 79); // Red
    doc.text(`Balance Check - Difference: UGX ${numberWithCommas(Math.abs(balanceCheck))}`, 14, startY);
  }
  doc.setTextColor(0, 0, 0); // Reset to black

  const fileName = `BALANCE_SHEET_AS_OF_${dayjs(asOfDate).format("YYYY-MM-DD")}.pdf`;
  doc.save(fileName);
};

export default generateBalanceSheetPdf;

